export default __webpack_public_path__ + "static/media/ic_cancel.20eae1b8.svg";